const GITHUB_API_KEY = "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";
const SMTP_USER = "support@glimmr.app";
const SMTP_PASSWORD = "rjhqpxtxknbqdobj";
const SMTP_FROM = "Glimmr <support@glimmr.app>";
const LICENSE_MIN_PRICE = "1.99";
const LICENSE_MAX_PRICE = "5.99";
const STRIPE_SECRET_KEY = "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";
const STRIPE_PRODUCT_ID = "prod_RV174P8sBonywM";
export {
  GITHUB_API_KEY as G,
  LICENSE_MIN_PRICE as L,
  SMTP_USER as S,
  LICENSE_MAX_PRICE as a,
  SMTP_PASSWORD as b,
  SMTP_FROM as c,
  STRIPE_PRODUCT_ID as d,
  STRIPE_SECRET_KEY as e
};
